import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Button,
  IconButton,
} from '@americanexpress/dls-react';
import { IconPlus } from '@americanexpress/dls-icons';
import { useSelector } from 'react-redux';
import {
  useCommonContent,
  useOneCmsLocalePartners,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { cn } from '@/helpers/utils';
import LFCarousel from '../common/carousel/LFCarousel';
import styles from './LandingPartnerLogosSection.module.scss';
import LoungeTypeBadge from '../common/LoungeTypeBadge';

const GLOBAL_LOUNGE_COLLECTION_PARTNER_NAME =
  'The American Express Global Lounge Collection®';

const LandingPartnerLogosSection = () => {
  const partners = useOneCmsLocalePartners();
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const { partners: commonContentPartners } = useCommonContent();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileQuery = window.matchMedia('(max-width: 567px)');
    setIsMobile(mobileQuery.matches);

    const handleResize = (e) => setIsMobile(e.matches);
    mobileQuery.addEventListener('change', handleResize);
    return () => mobileQuery.removeEventListener('change', handleResize);
  }, []);

  const hasGlobalLoungeCollectionPartner = partners.some(
    (item) => item.partner_name === GLOBAL_LOUNGE_COLLECTION_PARTNER_NAME
  );

  let displayedPartners = partners.filter((partner) => partner.logo);

  if (isMobile && !hasGlobalLoungeCollectionPartner) {
    displayedPartners.unshift({
      logo: 'the-centurion-network-lounge-mobile.png',
      link_URL: '',
      link_label: '',
      partner_name: GLOBAL_LOUNGE_COLLECTION_PARTNER_NAME,
    });
  }

  if (!isMobile && hasGlobalLoungeCollectionPartner) {
    displayedPartners = displayedPartners.filter(
      (partner) =>
        partner.partner_name !== GLOBAL_LOUNGE_COLLECTION_PARTNER_NAME
    );
  }

  return (
    <>
      {!isMobile && (
        <h2 className="tw-heading-md-regular tw-mb-6 tw-mt-10 tw-text-gray-900">
          {commonContentPartners.sectionHeader || 'All Partners'}
        </h2>
      )}
      <LFCarousel
        id="partners-carousel"
        data-testid="partners-carousel"
        innerContainerClassName="tw-rounded-2xl"
      >
        {displayedPartners?.map(
          ({
            logo: partnerLogo,
            link_URL: linkUrl,
            partner_name: partnerName,
          }) => {
            return (
              <div key={partnerName}>
                <Card
                  key={partnerName}
                  className={`tw-w-full tw-rounded-2xl tw-border tw-border-gray-300 ${partnerName !== 'The American Express Global Lounge Collection®' ? 'first-child_tw-flex first-child_tw-items-center first-child_tw-justify-center first-child_tw-shadow-none' : ''} ${partnerName === 'The American Express Global Lounge Collection®' ? 'tw-border-none tw-px-0 first-child_tw-bg-blue-deep-700' : ''}`}
                  innerContainerClassName="tw-p-0 tw-rounded-2xl"
                >
                  {isMobile &&
                  partnerName ===
                    'The American Express Global Lounge Collection®' ? (
                    <div className="tw-bg-blue-deep-700">
                      <CardMedia className="tw-flex tw-px-0">
                        <img
                          src={`${baseOneCmsImgUrl}${partnerLogo}`}
                          alt={partnerName}
                          style={{ height: '190px' }}
                        />
                      </CardMedia>
                      <CardContent alignment="center" className="tw-m-6 tw-p-0">
                        <h2
                          className={cn(
                            'tw-heading-md-medium tw-mb-1 tw-p-0 tw-text-left tw-text-gray-100'
                          )}
                        >
                          {commonContentPartners.cnHeader}
                        </h2>
                        <p className={cn('tw-text-left tw-text-gray-100')}>
                          {commonContentPartners.cnDescription}
                        </p>
                        <div className="tw-w-full">
                          <Button
                            className="tw-mt-4 tw-w-full tw-max-w-none"
                            variant="primary"
                            href={linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {commonContentPartners.cnCTALabel}
                          </Button>
                        </div>
                      </CardContent>
                    </div>
                  ) : (
                    <div>
                      {partnerName.includes('Priority Pass') && (
                        <>
                          <LoungeTypeBadge
                            badgeType="priorityPass"
                            className={styles.loungeBadgeType}
                          />
                          <IconButton
                            size="sm"
                            className={styles.loungeBadgeIconLink}
                          >
                            <IconPlus size="sm" />
                          </IconButton>
                        </>
                      )}
                      <CardMedia className={styles.partnerLogoImage}>
                        <img
                          src={`${baseOneCmsImgUrl}${`${partnerLogo}-default.png`}`}
                          alt={partnerName}
                          className={styles.partnerLogoImageDefault}
                        />

                        <img
                          src={`${baseOneCmsImgUrl}${`${partnerLogo}-hover.png`}`}
                          alt={partnerName}
                          className={styles.partnerLogoImageHover}
                        />
                      </CardMedia>
                    </div>
                  )}
                </Card>
              </div>
            );
          }
        )}
      </LFCarousel>
    </>
  );
};

export default LandingPartnerLogosSection;
